import { render, staticRenderFns } from "./GPToCostReport.vue?vue&type=template&id=304d1b7e"
import script from "./GPToCostReport.vue?vue&type=script&lang=js"
export * from "./GPToCostReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports